<template>
  <OffersTable
    id="participant-group-sub-table"
    ref="offers_table"
    :contranct-props="contranctProps"
    :critery-card="criteryCard"
    :currencies="currencies"
    :headers="offersSubHeaders"
    :items.sync="item.positions"
    :mode="`${mode ? mode + '-' : ''}lotGroups`"
    :only_review="only_review"
    :tender="tender"
    :without_select="true">
    <template #expanded-item="{ item: offer }">
      <td :colspan="offersSubHeaders.length">
        <OffersParticipantGroupSubTableDetails
          class="offer-sub-expanded-details"
          :item="offer"/>
      </td>
    </template>
  </OffersTable>
</template>
<script>
import OffersTable from 'components/tenders/tender page/offersGroups/OffersTable.vue'
import OffersParticipantGroupSubTableDetails from 'components/tenders/tender page/offersGroups/OffersParticipantGroupSubTableDetails.vue'

import tableMixin from 'mixins/tableMixin'
import offersHeadersMixin from 'mixins/offersHeadersMixin'

export default {
  name: 'offersParticipantGroupSubTable',
  mixins: [
    tableMixin,
    offersHeadersMixin,
  ],
  data() {
    return {
      offersSubHeaders: [],
    }
  },
  methods: {
    createHeader() {
      let status = this.tender.tenderStatus?.id
      let headers = [
        { text: 'Назва позиції', value: 'lotTitleOrig', coef_width: '3'},
        { text: this.$t('Catalog.Amount'), value: 'quantity', coef_width: '2', class: 'header_break-spaces' },
        { text: this.$t('Catalog.Price'), value: 'price', coef_width: '1.2' },
        { text: this.$t('Tenders.TotalCostShort'), value: 'summ', coef_width: '1.2' },
      ]

      if (this.$can('is', 'tenderProposalShowIp') && this.mode !== 'history') {
        headers.push({ text: 'IP', value: 'ipAddress', width: '130px' })
      }

      this.$_handleTenderingForPercentage(headers)
      this.$_handleReducedPrice(headers)
      this._handleReductionStatus(headers, status)
      this._handlePrequalificationStatus(headers, status)
      this.$_handlePriceVisibility(headers)
      this.$_getHeadersWidthByCoef(headers)
      
      this.offersSubHeaders = headers
    },
    _handleReductionStatus(headers, status) {
      // редакцион + анализ или терминальные стадии
      const isReduction = this.tender?.biddingType?.multipleRoundsOnAuction && [this.statuseKeys.BID_ANALYSIS, this.statuseKeys.COMPLETED, this.statuseKeys.PURCHASE_NOT_PLACED, this.statuseKeys.CANCELED].includes(status)
      if (isReduction) {
        headers.splice(-1, 0,
          { text: this.$t('Purchasing.Status'), value: 'statusReduction', sortable: false, coef_width: '1.5' })
      }
    },
    _handlePrequalificationStatus(headers, status) {
      if (status == this.statuseKeys.PREQUALIFICATION || (status == this.statuseKeys.COMPLETED && this.tender?.biddingType?.isFrameFirstStage)) {
        headers.splice(-1, 0,
          { text: this.$t('Purchasing.Status'), value: 'status', sortable: false, coef_width: '1.5' })
      }
    },
  },
  components: {
    OffersTable,
    OffersParticipantGroupSubTableDetails
  },
  watch: {
    tender: {
      immediate: true,
      deep: true,
      handler(val, old) {
        if (val?.tenderId !== old?.tenderId) {
          this.createHeader()
        }
      }
    },
  },
  props: {
    item: {
      type: Object,
    },
    contranctProps: {
      type: Object
    },
    criteryCard: Object,
    currencies: Array,
    mode: String,
    only_review: Boolean,
    tender: Object,
  },
}
</script>
<style lang="scss">
:root {
  --thead-th: #D6EDEB;
  --tr-td: #EBF6F5;
  --expanded-details: #D6EDEB;
}
:root.dark-theme {
  --thead-th: #114134;
  --tr-td: #224139;
  --expanded-details: #1B3A36;
}
#participant-group-sub-table {
  &,
  & .v-data-table,
  & .v-data-table .v-data-table__wrapper {
    border-radius: 0 !important;
  }

  td:first-child,
  td:last-child {
    border-bottom: thin solid var(--v-main__green-base) !important;
  }

  td {
    border-left: none !important;
  }

  thead tr th {
    background-color: var(--thead-th) !important;
  }
  tr td {
    background-color: var(--tr-td) !important;
  }
  th:not(:first-child),
  th:first-child {
    height: 25px !important;
    min-height: 25px !important;
    border-left: none !important;
  }

  .offer-sub-expanded-details {
    background: var(--expanded-details) !important;
    margin: -10px -13px;
    padding: 0 0 15px 10px;
  }
}
</style>
